import { mapActions, mapGetters } from 'vuex'

import { cloneDeep, get } from 'lodash'

import { getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { PAYMENTS_METHODS, RECURRENT_PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { DEFAULT_INVOICE_PAYLOAD, DEFAULT_PAYMENT_PAYLOAD, getStorageURL, getURLtoAPI, globalErrorHandler, request, services } from '@/utils'

import render from './render'

const invoicesPathToAPI = getServicePathToAPI(services.invoices)
const paymentsPathToAPI = getServicePathToAPI(services.payments)

export default {
  name: 'GlobalPaymentDialog',

  data() {
    return {
      step: 'first',

      show: false,
      loading: false,

      payload: {
        legal: cloneDeep(DEFAULT_INVOICE_PAYLOAD),
        individual: cloneDeep(DEFAULT_PAYMENT_PAYLOAD),
        individualValidation: false
      }
    }
  },

  computed: {
    ...mapGetters({
      paymentsMethods: 'payments/methods',
      showPaymentDialog: 'payments/showPaymentDialog'
    }),

    validation() {
      const amount = get(this.payload, 'legal.amount', 0)

      return !!(this.payload.legal.requisiteId && this.payload.legal.companyId && amount > 0)
    },

    paymentTypes() {
      const result = [
        {
          name: 'legal',
          priority: 2
        }
      ]
      if (Array.isArray(this.$paymentsMethods) && this.$paymentsMethods.length) {
        result.push({
          name: 'individual',
          priority: 1
        })
      }

      return result.sort((a, b) => {
        return a.priority - b.priority
      }).map(({ name }) => {
        return name
      })
    },

    $paymentsMethods() {
      const result = []
      if (this.paymentsMethods.some(method => {
        return ~PAYMENTS_METHODS.indexOf(method)
      })) {
        result.push({
          name: 'cards',
          priority: 1
        })
      }
      if (this.paymentsMethods.some(method => {
        return ~RECURRENT_PAYMENTS_METHODS.indexOf(method)
      })) {
        result.push({
          name: 'recurrent',
          priority: 9
        })
      }

      return result.sort((a, b) => {
        return a.priority - b.priority
      }).map(({ name }) => {
        return name
      })
    }
  },

  methods: {
    ...mapActions({
      setCurrentTab: 'currentTab/setCurrentTab',
      setShowPaymentDialog: 'payments/setShowPaymentDialog',
      setShowCreateRecurrentPaymentDialog: 'payments/setShowCreateRecurrentPaymentDialog'
    }),

    async requestPayment() {
      if (!this.payload.individualValidation) {
        return
      }

      const method = this.payload.individual.method
      const amount = this.payload.individual.amount
      if (!amount || amount <= 0) {
        return
      }

      try {
        this.loading = true
        const body = {
          amount,
          method,
          urlSuccess: getURLtoAPI(joinURLPath(paymentsPathToAPI, 'webhook', method, 'success')),
          urlFail: getURLtoAPI(joinURLPath(paymentsPathToAPI, 'webhook', method, 'fail'))
        }
        const data = await request.create(paymentsPathToAPI, { body })
        if (data && data.url) {
          window.location.href = data.url
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    async requestDocument() {
      try {
        this.loading = true
        delete this.payload.type
        const data = await request.create(invoicesPathToAPI, { body: this.payload.legal }, { scopes: [ 'awaitDocument' ] })
        if (data) {
          window.location.href = getStorageURL([ get(data, 'Owner.id', data.OwnerId), data.documentId ])
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    async paymentMethodClickHandler(method) {
      switch (method) {
        case 'recurrent': {
          const { name, query } = this.$router.currentRoute
          if (name !== 'account' && query.currentTab !== services.recurrentPayments) {
            this.$router.push({
              name: 'account',
              hash: 'recurrentPayments'
            })
          } else {
            this.setCurrentTab({ name: services.recurrentPayments })
          }
          this.setShowPaymentDialog(false)
          this.setShowCreateRecurrentPaymentDialog(true)
          break
        }
        case 'cards':
        default: {
          this.step = method
          break
        }
      }
    }
  },

  render
}
